module.exports = __webpack_public_path__ + "static/Creator 12 - @Athieno-78b665b183b1b6b3592b558955450bfc.png";